import axios from "../Interceptor/interceptor";
import {store} from "../store";
// import {toast} from "react-toastify";

export const callTypes = {
    get: "GET",
    post: "POST",
    upload: "UPLOAD",
    put: "PUT",
    delete: "DELETE",
    patch: "PATCH",
};

export function showToast(error) {
    let errorMsg = "";
    if (error?.data?.response) {
        errorMsg = error?.data.message || error?.data.response?.message;
    } else {
        errorMsg = 'Opps! Something went wrong.';
    }
    // toast.error(errorMsg);
}

export default async function callWebService(requestType, data, url, config) {
    switch (requestType) {
        case callTypes.get: {
            const getApiResult = await axios.get(url).catch((error) => {
                showToast(error);
            });
            if (getApiResult?.data?.response?.status === false) {
                showToast(getApiResult);
            }
            return getApiResult;
        }
        case callTypes.post: {
            const postApiResult = await axios
                .post(url, data, config)
                .catch((error) => {
                    console.log(error)
                    showToast(error);
                });
            if (postApiResult?.data?.response?.status === false) {
                showToast(postApiResult);
            }
            return postApiResult;
        }
        case callTypes.put: {
            const putApiResult = await axios.put(url, data).catch((error) => {
                showToast(error);
            });
            if (putApiResult?.data?.response?.status === false) {
                showToast(putApiResult);
            }
            return putApiResult;
        }
        case callTypes.delete: {
            const deleteApiResult = await axios
                .delete(url, { data })
                .catch((error) => {
                    showToast(error);
                });
            if (deleteApiResult?.data?.response?.status === false) {
                showToast(deleteApiResult);
            }
            return deleteApiResult;
        }
        case callTypes.patch: {
            const patchApiResult = await axios.patch(url, data).catch((error) => {
                showToast(error);
            });
            if (patchApiResult?.data?.response?.status === false) {
                showToast(patchApiResult);
            }
            return patchApiResult;
        }
    }
}
